import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import auth from "./authReducer";
import course from "./courseReducer";
import { studentCourse, studentResult } from "./studentReducer";
import {
  teacherStudentReducer,
  teacherInformationReducer,
} from "./teacherReducer";
import { productsReducer, studentWithLicenseReducer } from "./productsReducer";
import newCartReducer from "./newCartReducer";
import {
  studentResultsReducer,
  studentRunReducer,
  studentResultByStudentReducer,
  studentAverageResultByStudentReducer,
  studentResultTimelineReducer,
} from "./studentResultsReducer";
import { studentProfileReducer } from "./studentProfileReducer";
import { teacherResultsReducer } from "./teacherResultsReducer";
import { teacherCoursesReducer } from "./teacherCoursesReducer";
import { teacherModuleResultsReducer } from "./teacherModuleResultsReducer";
import { invoiceHistoryReducer } from "./invoiceHistoryReducer";
import { toggleFinalExamReducer } from "./toggleFinalExamReducer";
import { schoolReducer } from "./schoolReducer";
import { classReducer } from "./classReducer";
import { coursesListReducer } from "./coursesListReducer";
import { studentsForSchoolReducer } from "./studentForSchoolReducer";
import { moduleReducer, lwFileNameReducer } from "./moduleReducer";
import { adminUsersReducer } from "./adminUsersReducer";
import {
  coursesByClassReducer,
  coursesByProgramReducer,
  coursesByStudentReducer,
  coursesByTeacherReducer,
  bestCourseBySchoolReducer,
  coursesInProgressBySchoolReducer,
} from "./courseReducer";
import { programmeReducer, fortnoxProgramReducer } from "./programmeReducer";
import { orientationReducer } from "./orientationReducer";
import { schoolDataReducer } from "./schoolDataReducer";
import {
  finalExamReducer,
  nbrOfActivatedFinalExamsReducer,
} from "./finalExamReducer";
import {
  programLicenseReducer,
  programLicenseByCustomerReducer,
} from "./programLicenseReducer";
import {
  studentRatingsReducer,
  moduleRatingsReducer,
  avgRatingsReducer,
  studentTotalRatingsReducer,
} from "./ratingsReducer";
import { teacherTabNavReducer } from "./teacherTabNavReducer";
import { notificationsReducer } from "./notificationsReducer";
import { scrollReducer } from "./scrollReducer";

export default combineReducers({
  auth,
  form: formReducer,
  course,
  studentCourse,
  studentResult,
  teacherStudentReducer,
  productsReducer,
  newCartReducer,
  studentResultsReducer,
  studentProfileReducer,
  teacherResultsReducer,
  teacherCoursesReducer,
  teacherModuleResultsReducer,
  teacherInformationReducer,
  invoiceHistoryReducer,
  toggleFinalExamReducer,
  schoolReducer,
  classReducer,
  coursesListReducer,
  studentsForSchoolReducer,
  moduleReducer,
  adminUsersReducer,
  studentRunReducer,
  studentResultByStudentReducer,
  coursesByClassReducer,
  coursesByProgramReducer,
  coursesByStudentReducer,
  coursesByTeacherReducer,
  programmeReducer,
  orientationReducer,
  schoolDataReducer,
  bestCourseBySchoolReducer,
  coursesInProgressBySchoolReducer,
  finalExamReducer,
  nbrOfActivatedFinalExamsReducer,
  studentAverageResultByStudentReducer,
  studentResultTimelineReducer,
  programLicenseReducer,
  programLicenseByCustomerReducer,
  studentWithLicenseReducer,
  fortnoxProgramReducer,
  lwFileNameReducer,
  studentRatingsReducer,
  moduleRatingsReducer,
  avgRatingsReducer,
  studentTotalRatingsReducer,
  teacherTabNavReducer,
  notificationsReducer,
  scrollReducer,
});
